/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Uno_Compose_StepInputs */



/**
* | output |
* | --- |
* | "Question {current} of {total}" |
*
* @param {Uno_Compose_StepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_compose_step = /** @type {((inputs: Uno_Compose_StepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Compose_StepInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Frage ${i?.current} von ${i?.total}`)
	return /** @type {LocalizedString} */ (`Question ${i?.current} of ${i?.total}`)
});